import { DateTime } from "luxon";
import formatDateTime from "../../../utils/formatDateTime";
import ContactFromId from "../../contacts/ContactFromId";
import { IPart } from "../../../models/Part";

export interface UnlistedDetailsCardProps {
  fullPart: IPart;
}

export default function UnlistedDetailsCard({
  fullPart,
}: UnlistedDetailsCardProps) {

  const actions = [
    {
      label: "Dismantled",
      date: fullPart.removedOn
        ? formatDateTime(fullPart.removedOn, DateTime.DATETIME_SHORT)
        : "Not dismantled",
      by: fullPart.removedBy,
    },
    {
      label: "Imaged",
      date: fullPart.imagedOn
        ? formatDateTime(fullPart.imagedOn, DateTime.DATETIME_SHORT)
        : "Not imaged",
      by: fullPart.imagedBy,
    },
    {
      label: "Priced",
      date: fullPart.pricedOn
        ? formatDateTime(fullPart.pricedOn, DateTime.DATETIME_SHORT)
        : "Not priced",
      by: fullPart.pricedBy,
    },
    {
      label: "Scrapped On",
      date: fullPart.scrappedOn
        ? formatDateTime(fullPart.scrappedOn, DateTime.DATETIME_SHORT)
        : "Not scrapped",
      by: fullPart.scrappedBy,
    },
    {
      label: "Located On",
      date: fullPart.locatedOn
        ? formatDateTime(fullPart.locatedOn, DateTime.DATETIME_SHORT)
        : "Not located",
      by: fullPart.locatedBy,
    },
        {
      label: "Shipped On",
      date: fullPart.shippedOn
        ? formatDateTime(fullPart.shippedOn, DateTime.DATETIME_SHORT)
        : "Not shipped",
      by: fullPart.shippedBy,
    },

  ];

  return (
    <div className="flex flex-col gap-y-4 sm:col-span-2 col-span-1">
      <div className="border border-gray-300 rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 border-b border-gray-400">
                Action
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 border-b border-gray-400">
                On
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-700 border-b border-gray-400">
                By
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {actions.map((action) => (
              <tr
                key={action.label}
                className="border-b border-gray-200 odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition"
              >
                <td className="px-3 py-2 text-sm font-medium text-gray-900">
                  {action.label}
                </td>

                <td className="px-3 py-2 text-sm text-gray-700">
                  {action.date}
                </td>

                <td className="px-3 py-2 text-sm text-gray-700">
                  {action.by ? (
                    <ContactFromId contactId={action.by} />
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
